import clsx from "clsx"
import {GatsbyImage, IGatsbyImageData} from "gatsby-plugin-image"
import RichTextField from "~/components/UI/RichText/RichText"
import "./CaseHistorySection.css"

interface CaseHistorySectionProps extends Omit<React.HTMLAttributes<HTMLSelectElement>, "title"> {
    name?: string | null | undefined
    title: string | null | undefined
    backgroundImage?: IGatsbyImageData | null | undefined
    backgroundAlt?: string | null | undefined
    showcase?: React.ReactNode
}

const CaseHistorySection: React.FC<CaseHistorySectionProps> = props => {
    const {name, showcase, title, backgroundImage, backgroundAlt, className, children, ...otherProps} = props
    return (
        <section
            className={clsx(
                "case-history-section-5v37",
                backgroundImage && backgroundAlt ? "chs-with-background-5v37" : "",
                showcase ? "chs-with-show-case-5v37" : "",
                className,
            )}
            {...otherProps}
        >
            <div className="chs-container-5v37">
                {backgroundImage && backgroundAlt && (
                    <GatsbyImage alt={backgroundAlt} image={backgroundImage} className="chs-background-5v37" />
                )}
                {name && <h5 className="chs-name-5v37">{name}</h5>}
                <div className="chs-content-5v37">
                    <h4 className="chs-title-5v37">{title}</h4>
                    <RichTextField className="chs-text-5v37">{children}</RichTextField>
                    {showcase && <div className="chs-showcase-5v37">{showcase}</div>}
                </div>
            </div>
        </section>
    )
}

export default CaseHistorySection
